import styled from 'styled-components';
import { variant, themeGet } from 'styled-system';

import { basicTheme, candidateTheme } from 'src/theme';
import { Flex, FlexProps } from 'src/kit';
import { controlSize, errorsStyles } from '../styles';

const radioButtonVariant = variant({
  key: 'radioButtons'
});

export const FakeRadioButton = styled.div<{ size?: keyof typeof basicTheme.controlSizes }>`
  cursor: pointer;
  display: flex;
  color: ${themeGet('colors.textSecondary')};
  align-items: center;
  justify-content: center;
  ${controlSize};
  ${errorsStyles};
`;

export const StyledRadioInput = styled.input.attrs(props => ({ type: 'radio' }))`
  position: absolute;
  opacity: 0;
`;

export type StyledLabelProps = FlexProps & {
  variant?: keyof typeof basicTheme.radioButtons | keyof typeof candidateTheme.radioButtons;
  size?: keyof typeof basicTheme.controlSizes;
};
export const StyledLabel = styled(Flex).attrs(props => ({ as: 'label' }))<StyledLabelProps>`
  display: flex;
  align-items: center;
  ${radioButtonVariant};
`;

StyledLabel.defaultProps = {
  variant: 'primary'
};
